/* eslint camelcase: 0 */
var Stream = require('stream')

var debounce = require('../utils/debounce')

function XHRStream(request, method, path, headers, body) {
  if (!(this instanceof XHRStream)) {
    return new XHRStream(request, method, path, headers, body)
  }

  Stream.call(this)

  this.readable = true
  this.writable = true

  this.in_progress = false
  this.drop_request = false
  this.request = request
  this.method = method
  this.path = path
  this.headers = headers
  this.body = body
  this.xhr = null

  this._debounce_ms = 0

  // prevent throw on failures with no listeners
  this.on('error', noop)
}

var cons = XHRStream,
  proto = (cons.prototype = Object.create(Stream.prototype))

proto.constructor = cons

proto.set_debounce_ms = function(ms) {
  this._debounce_ms = ms
}

proto.write = function() {
  if (this.in_progress) {
    return false
  }

  var args = this.get_args([].slice.call(arguments)),
    on_write = this.get_on_write()

  on_write(args)
}

proto.end = function() {
  this.emit('end')
}

proto.get_args = function(args) {
  var count = 0,
    our_args = [this.method, this.path, this.headers, this.body]

  for (var i = 0, len = our_args.length; i < len; ++i) {
    if (our_args[i] === undefined) {
      our_args[i] = args[count++]
    }
  }

  return our_args.filter(Boolean)
}

proto.get_on_write = function() {
  this._on_write =
    this._on_write || debounce(this.start_xhr.bind(this), this._debounce_ms)

  return this._on_write
}

proto.start_xhr = function(args) {
  var self = this

  self.emit('request', args)
  self.in_progress = true
  self.xhr = self.request.apply(null, args.concat(onready))

  function onready(err, data, headers) {
    if (self.drop_request) {
      self.cleanup()

      return
    }

    if (err) {
      self.emit('error', err)
      self.cleanup()

      return
    }

    self.emit('data', data, headers)
    self.cleanup()
  }
}

proto.cancel = function() {
  this.drop_request = true

  if (this._on_write) {
    this._on_write.clear()
  }

  if (!this.in_progress) {
    this.cleanup()
  }
}

proto.cleanup = function() {
  this.in_progress = false
  this.xhr = null
  this.drop_request = false

  this.emit('drain')
}

module.exports = cons

function noop() {
  // nooperations
}
